import { useCallback, useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { groupByValues } from '@/metrics/constants'
import { getFilterParams } from '@/metrics/helpers/helpers'
import metricsServices from '@/metrics/services/services'

const useVariantMetrics = ({
  returnPortalId,
  setCommonFilters,
  commonFilters,
  productPosition,
  variantPosition,
  productsFilters,
}) => {
  const [variant, setVariant] = useState()
  const [productId, setProductId] = useState()
  const [parentProduct, setParentProduct] = useState()

  const { fetchData: fetchVariants, loading: loadingVariant } = useFetch(metricsServices.getProductTopVariants, {
    doInitialRequest: false,
  })

  const { fetchData: fetchTopReturnedProducts, loading: loadingTopReturnedProducts } = useFetch(
    metricsServices.getTopReturnedProducts,
    {
      doInitialRequest: false,
    }
  )

  const getVariantByProductId = useCallback(
    async productIdSelected => {
      const variants = await fetchVariants({
        returnPortalId,
        productId: productIdSelected,
        params: getFilterParams({
          ...commonFilters,
          ordering: productsFilters?.ordering,
          query: productsFilters?.query,
        }),
      })

      const selectedVariant = variants?.results?.[variantPosition]
      setVariant({ ...selectedVariant, variant_id: selectedVariant?.id })
    },
    [returnPortalId, commonFilters, fetchVariants, variantPosition, productsFilters]
  )

  const getVariantByGroupBy = useCallback(
    async groupBy => {
      const topReturnedProducts = await fetchTopReturnedProducts({
        returnPortalId,
        params: getFilterParams({
          ...commonFilters,
          groupBy,
          ordering: productsFilters?.ordering,
          query: productsFilters?.query,
        }),
      })

      if (groupBy === groupByValues.variants) {
        setProductId(topReturnedProducts?.results?.[variantPosition]?.product_id)
        setVariant({
          ...topReturnedProducts?.results?.[variantPosition],
          variant_id: topReturnedProducts?.results?.[variantPosition]?.id,
        })
      } else {
        setParentProduct(topReturnedProducts?.results?.[productPosition])
        setProductId(topReturnedProducts?.results?.[productPosition]?.id)
        getVariantByProductId(topReturnedProducts?.results?.[productPosition]?.id)
      }
    },
    [
      returnPortalId,
      commonFilters,
      fetchTopReturnedProducts,
      variantPosition,
      productPosition,
      getVariantByProductId,
      productsFilters,
    ]
  )

  useEffect(() => {
    if (!variant) {
      if (!productPosition) {
        getVariantByGroupBy(groupByValues.variants)
      } else {
        getVariantByGroupBy(groupByValues.products)
      }
    }
  }, [productPosition, commonFilters, variantPosition, productId, variant, getVariantByGroupBy])

  const handleFiltersChange = filters => {
    setVariant(null)
    setCommonFilters(filters)
  }

  return {
    variant,
    handleFiltersChange,
    loadingVariant: loadingVariant || loadingTopReturnedProducts,
    productId,
    parentProduct,
  }
}

export default useVariantMetrics
